export default __webpack_public_path__ + "static/media/amparo-arte-5.d1d97ae4.webp";